import React from 'react';
import { connect } from 'react-redux';
import { request, internalUpdate } from '../../redux/actions/genericAction';
import { loginRequest } from '../../redux/actions/dashboardAction';
import { loadDashboardSettings } from '../../redux/actions/dashboardAction';
import { internalProgramsUpdate } from '../../redux/actions/rawProgramAction';
import { Redirect} from 'react-router-dom';
import { TitleBar } from '../common/theme';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import { toArray, convertDictionaryKeys } from '../../Utils';
import Spinner from '../common/generic/Spinner';
import { debugMode, getLogoutDomain } from '../../ApiHelper';

class LoginPage extends React.Component {

  state = {
    toDashboard: false,
    schoolID: '9c2a181c317d19c524bddc25f62d4c9f',
    userID: '9c2a181c317d19c524bddc25f62d4c9f',
    loadType: 'Admin',
    redirect: false
  }

  loginAdmin = () =>{
    let transfer = JSON.parse(sessionStorage.getItem('transfer'));
    sessionStorage.removeItem('transfer');
    let schoolID= '9c2a181c317d19c524bddc25f62d4c9f';
    let userID= '9c2a181c317d19c524bddc25f62d4c9f';
    if(transfer){
      sessionStorage.setItem('token',transfer.data.Token);
      sessionStorage.setItem('userID',transfer.data.userID);
      sessionStorage.setItem('custID',transfer.data.customerID);
      schoolID= transfer.data.customerID;
      userID= transfer.data.userID;        
    }
    else{
      sessionStorage.setItem('token','secToken');
      sessionStorage.setItem('userID',this.state.userID);
      sessionStorage.setItem('custID',this.state.schoolID);
      this.props.request({
        params: this.state.schoolID,
        func:'createSecurityTagTemp',
      });        
    }

    this.setState((state) => ({ ...state, userID, schoolID, loadType: 'Admin' }));
    this.props.loadDashboardSettings({login:'Admin'});

  };

  loginTeacher = () =>{
    
    let transfer = JSON.parse(sessionStorage.getItem('transfer'));
    sessionStorage.removeItem('transfer');
    let userID = '5727';
    let schoolID= '9c2a181c317d19c524bddc25f62d4c9f';
    if(transfer){
      sessionStorage.setItem('token',transfer.data.Token);
      sessionStorage.setItem('userID',transfer.data.userID);
      sessionStorage.setItem('custID',transfer.data.customerID);
      schoolID= transfer.data.customerID;
      userID= transfer.data.userID; 
    }
    else{
      sessionStorage.setItem('token','secToken');
      sessionStorage.setItem('userID','5727');
      sessionStorage.setItem('custID', schoolID);
      this.props.request({
        params: '5727',
        func:'createSecurityTagTemp',
      });  
    }

    this.props.internalUpdate('teacherID',userID);

    this.setState((state) => ({ ...state, userID, schoolID, loadType: 'Teacher' }));
    this.props.loadDashboardSettings({login:'Teacher'});
  };
  loading = false;

  componentDidMount(){
    let transfer = JSON.parse(sessionStorage.getItem('transfer'));
    if(transfer){
      if(transfer.type==='admin'){
        this.loginAdmin();
      }
      if(transfer.type==='teacher'){
        this.loginTeacher();
      }
    }
    else{
      // console.log('Expired from IdleTimer');
      // console.log(sessionStorage.getItem('transfer'));
      // console.log({transfer});
      
      this.setRedirect();
    }
  }
  componentDidUpdate(){
    if(this.state.loadType==='Admin')
      this.loadAdmin();
    if(this.state.loadType==='Teacher')
      this.loadTeacher();        
  }

  loadTeacher(){
    if(this.props.database['getCustomer'] && this.props.database['getCustomer'].isLoaded
      && this.props.database['getAllPrograms'] && this.props.database['getAllPrograms'].isLoaded
      && this.props.database['getAllUserPrograms'] && this.props.database['getAllUserPrograms'].isLoaded
      && this.props.database['getAllClasses'] && this.props.database['getAllClasses'].isLoaded  
      && this.props.database['getAllStudentsForSchool'] && this.props.database['getAllStudentsForSchool'].isLoaded        
      && this.props.database['getStudentsForClass'] && this.props.database['getStudentsForClass'].isLoaded 
      ){

        let builderID='0000000000000000';
        let builderProgram = toArray(this.props.database['getAllPrograms'].data).find(e=>e.DataPath);
        if(builderProgram) builderID = builderProgram.DataPath;
        sessionStorage.setItem('productionPath', builderID); // This will get changed when the user chooses a program to view a report/assignment with
        sessionStorage.setItem('productionPathStatic', builderID); // This is the productionPath thats currently assigned to this use in the CustomerDB (Dont change it)

        this.props.database['getAllClasses'].data = convertDictionaryKeys(this.props.database['getAllClasses'].data, 'ClassID');
      
        Object.keys(this.props.database['getAllClasses'].data).map((classKey) => {
          let classRec = this.props.database['getAllClasses'].data[classKey];
          let allStudentsArray = toArray(this.props.database['getAllStudentsForSchool'].data); 
          let studentRecs = allStudentsArray.filter(studentRec => studentRec.ClassID === classRec.ClassID);           
          this.props.database['getAllClasses'].data[classKey].students = studentRecs;
        });

        // Add user created programs
        let userProgs = [];
        if(builderID!=='0000000000000000'){
          Object.keys(this.props.database['getAllUserPrograms'].data).map((key,i)=>{
            const e = this.props.database['getAllUserPrograms'].data[key];
            let userProg = { 
              schoolID:e['SchoolID'],
              id: e['progID'].toUpperCase()+'-'+e['ContentID'],
              categ: 'User',
              gradeTitle: e['Title'],
              title: e['Title'],
              shortTitle: e['ShortTitle'],
              modules:[[e['progID'].toUpperCase(),e['Description']]],
              order: i,
              suborder:3,
              subcateg: 'User Programs',
              authorID: e['TeacherID'],
              standard:e['Standard'],
              version:e['Version'],
              Description:e['Description'],
              productionPath:e['productionPath'],
              tags:e['Tags']              
            };
            this.props.database['getAllPrograms'].data[e['progID'].toUpperCase()+'-'+e['ContentID']]={...userProg};
            userProgs.push({...userProg});
          });   
        }

        if(userProgs.length>0){          
          if(this.props.rawPrograms.programs.filter(e => e.id === userProgs[0].id).length === 0 ){
            userProgs = [...this.props.rawPrograms.programs, ...userProgs];
            this.props.internalUpdate('getAllUserPrograms',JSON.parse(JSON.stringify(this.props.database['getAllUserPrograms'])));
            this.props.internalProgramsUpdate(userProgs);
          }
        }

        let basicSkills = toArray(this.props.database['getAllPrograms'].data).find(e=>e.NAME==='Complete Basic Skills');
        let licence = 2500;
        if(basicSkills && basicSkills.License.split('-')[1]!=='500+')
          licence = parseInt(basicSkills.License.split('-')[1]);
        this.props.database['userLimit'] = licence;

        this.setState((state) => ({ ...state, toDashboard: true }));
        this.loading = false;
    }

    if(this.loading) return;

    if(sessionStorage.getItem('token')==='secToken' && (!this.props.database['createSecurityTagTemp'] || !this.props.database['createSecurityTagTemp'].data)) return;
    if(sessionStorage.getItem('token')==='secToken')
      sessionStorage.setItem('token', this.props.database['createSecurityTagTemp'].data);
    
    const isCleverPaidLibMode=()=>(sessionStorage.getItem('LTIMode') !== null && sessionStorage.getItem('LTIMode')=="Clever_Library");
    // const isCleverSyncMode=()=>(sessionStorage.getItem('LTIMode') !== null && sessionStorage.getItem('LTIMode')=="Clever_Sync");
    // const isCleverSharedFreeLibMode=()=>(sessionStorage.getItem('LTIMode') !== null && sessionStorage.getItem('LTIMode')=="Clever_Shared");
    const isCleverSharedPaidLibMode=()=>(sessionStorage.getItem('LTIMode') !== null && sessionStorage.getItem('LTIMode')=="Clever_Sync_Lib");

    if(!this.props.database['getAllPrograms']){
      this.loading = true;

      let getStudentsForClassSchoolQuery = {
        params: this.state.userID,
        altName: 'getAllStudentsForSchool',
        func:'getStudentsForClass',
      };

      // let getAllStudentsQuery = {
      //   params: this.state.schoolID,
      //   func:'getAllStudentsForSchool',
      // };
      
      let getStudentsForClassQuery = {
        params: this.state.userID,
        func:'getStudentsForClass',
        nextRequest: getStudentsForClassSchoolQuery
      };      

      let getAllClassesQuery = {
        params: `${this.state.schoolID}`,
        func:'getAllClasses',
        nextRequest: getStudentsForClassQuery
      };
    
      // let getAllClassesQuery = {
      //   params: `${this.state.schoolID}~${this.state.userID}`,
      //   func:'getAllClasses',
      //   nextRequest: getStudentsForClassQuery
      // };
      
      let trackNewVersionTeacher = {
        params: `${this.state.schoolID}`,
        func:'trackNewVersionTeacher',
        nextRequest: getAllClassesQuery
      };

      let getAllUserProgramsQuery = {
        params: this.state.schoolID,
        func:'getAllUserPrograms',
        nextRequest: trackNewVersionTeacher
      };
      
      let getAllProgramsQuery = {
        params: this.state.schoolID,
        func:'getAllPrograms',
        nextRequest: getAllUserProgramsQuery
      };

      // **************** Add Clever Programs *****************
      if(isCleverPaidLibMode()){ 
        getAllProgramsQuery = {
          params: `${this.state.schoolID}~${sessionStorage.getItem('userID')}`,
          altName: 'getAllPrograms',
          func:'getAllCleverLibPrograms',
          nextRequest: getAllUserProgramsQuery
          };
      }            

      if(isCleverSharedPaidLibMode()){
        getAllProgramsQuery = {
          params: `${this.state.schoolID}~${sessionStorage.getItem('userID')}`,
          altName: 'getAllPrograms',
          func:'getAllCleverPrograms',
          nextRequest: getAllUserProgramsQuery
          };
      } 

      let getCustomerQuery={
        params: `${this.state.schoolID}~true`,
        func:'getCustomer',
        nextRequest: getAllProgramsQuery            
      };
      this.props.request(getCustomerQuery);
    }
  }

  loadAdmin(){
    if(this.props.database['getCustomer'] && this.props.database['getCustomer'].isLoaded
      && this.props.database['getAllPrograms'] && this.props.database['getAllPrograms'].isLoaded
      && this.props.database['getAllUserPrograms'] && this.props.database['getAllUserPrograms'].isLoaded
      && this.props.database['getAllClasses'] && this.props.database['getAllClasses'].isLoaded  
      && this.props.database['getAllStudentsForSchool'] && this.props.database['getAllStudentsForSchool'].isLoaded        
      ){

        let builderID='0000000000000000';
        let builderProgram = toArray(this.props.database['getAllPrograms'].data).find(e=>e.DataPath);
        if(builderProgram) builderID = builderProgram.DataPath;
        sessionStorage.setItem('productionPath', builderID); // This will get changed when the user chooses a program to view a report/assignment with
        sessionStorage.setItem('productionPathStatic', builderID); // This is the productionPath thats currently assigned to this use in the CustomerDB (Dont change it)

        this.props.database['getAllClasses'].data = convertDictionaryKeys(this.props.database['getAllClasses'].data, 'ClassID');

        Object.keys(this.props.database['getAllClasses'].data).map((classKey) => {
          let classRec = this.props.database['getAllClasses'].data[classKey];
          let allStudentsArray = toArray(this.props.database['getAllStudentsForSchool'].data); 
          let studentRecs = allStudentsArray.filter(studentRec => studentRec.ClassID === classRec.ClassID);           
          this.props.database['getAllClasses'].data[classKey].students = studentRecs;
        });

        // Add user created programs
        let userProgs = [];
        if(builderID!=='0000000000000000'){
          Object.keys(this.props.database['getAllUserPrograms'].data).map((key,i)=>{
            const e = this.props.database['getAllUserPrograms'].data[key];
            let userProg = { 
              schoolID:e['SchoolID'],
              id: e['progID'].toUpperCase()+'-'+e['ContentID'],
              categ: 'User',
              gradeTitle: e['Title'],
              title: e['Title'],
              shortTitle: e['ShortTitle'],
              modules:[[e['progID'].toUpperCase(),e['Description']]],
              order: i,
              suborder:3,
              subcateg: 'User Programs',
              authorID: e['TeacherID'],
              standard:e['Standard'],
              version:e['Version'],
              Description:e['Description'],
              productionPath:e['productionPath'],
              tags:e['Tags']
            };
            this.props.database['getAllPrograms'].data[e['progID'].toUpperCase()+'-'+e['ContentID']]={...userProg};
            userProgs.push({...userProg});
          });   
        }

        if(userProgs.length>0){
          
          if(this.props.rawPrograms.programs.filter(e => e.id === userProgs[0].id).length === 0 ){
            userProgs = [...this.props.rawPrograms.programs, ...userProgs];
            this.props.internalUpdate('getAllUserPrograms',JSON.parse(JSON.stringify(this.props.database['getAllUserPrograms'])));
            this.props.internalProgramsUpdate(userProgs);
          }
        }

        let basicSkills = toArray(this.props.database['getAllPrograms'].data).find(e=>e.NAME==='Complete Basic Skills');
        let licence = 2500;
        if(basicSkills && basicSkills.License.split('-')[1]!=='500+')
          licence = parseInt(basicSkills.License.split('-')[1]);
        this.props.database['userLimit'] = licence;

        this.setState((state) => ({ ...state, toDashboard: true }));
        this.loading = false;
    }

    if(this.loading) return;

    if(sessionStorage.getItem('token')==='secToken' && (!this.props.database['createSecurityTagTemp'] || !this.props.database['createSecurityTagTemp'].data)) return;

    if(sessionStorage.getItem('token')==='secToken')
      sessionStorage.setItem('token', this.props.database['createSecurityTagTemp'].data);

    if(!this.props.database['getAllPrograms']){
      this.loading = true;

      let getAllStudentsQuery = {
        params: this.state.schoolID,
        func:'getAllStudentsForSchool',
      };

      let getAllClassesQuery = {
        params: this.state.schoolID,
        func:'getAllClasses',
        nextRequest: getAllStudentsQuery
      };

      let trackNewVersionTeacher = {
        params: `${this.state.schoolID}`,
        func:'trackNewVersionTeacher',
        nextRequest: getAllClassesQuery
      };
      
      let getAllUserProgramsQuery = {
        params: this.state.schoolID,
        func:'getAllUserPrograms',
        nextRequest: trackNewVersionTeacher
      };

      let getAllProgramsQuery = {
        params: this.state.schoolID,
        func:'getAllPrograms',
        nextRequest: getAllUserProgramsQuery
      };

      let getCustomerQuery={
        params: `${this.state.schoolID}~true`,
        func:'getCustomer',
        nextRequest: getAllProgramsQuery            
      };
      this.props.request(getCustomerQuery);
    }
  }

  setRedirect = () => {
    this.setState({
      redirect: true
    });
  }
  renderRedirect = () => {
    if (this.state.redirect) {
      window.location.href=getLogoutDomain()+'login.php?haserror=true';
      // return <Redirect to={dashboardDomain} />;
    }
  }

  render() {
    if (this.state.toDashboard === true) {
      if(this.state.loadType==='Admin' && toArray(this.props.database['getAllClasses'].data).length===0)
        return <Redirect to='/users' />;  
      if(this.state.loadType!=='Admin' && toArray(this.props.database['getStudentsForClass'].data).length === 0)        
        return <Redirect to='/users' />;  
      return <Redirect to='/summary' />;
    }

    return (
      <div>
          {this.renderRedirect()}
          <br/>
          <Container>
              <TitleBar>
                <Col  style={{textAlign: 'left', color: 'white' }} xs='12'><h3>Please Wait ...</h3></Col>
              </TitleBar>
          </Container>            
          <br/> 
          {debugMode && <>
            <Button onClick={this.loginAdmin}>Auto Admin Login</Button> <Button onClick={this.loginTeacher}>Auto Teacher Login</Button>
          </>}
          <br/><br/>{this.loading && <><Spinner/> <center>Loading...</center></>}
      </div>
    );
  }
}

const mapStateToProps = state => {
    return {
     token: state.dashboardReducer.token,
     database: state.genericReducer,
     rawPrograms: state.rawProgramReducer
   };
};

LoginPage = connect(
    mapStateToProps,
    {loadDashboardSettings, loginRequest, request, internalUpdate, internalProgramsUpdate}
)(LoginPage);

export default LoginPage;